import React, { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import LegacyDashboard from './LegacyDashboard';
import NewDashboard from './NewDashboard';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminCompaniesPage from './pages/AdminCompaniesPage';
import AdminDashboardDetailPage from './pages/AdminDashboardDetailPage';
import AdminAccessLogsPage from './pages/AdminAccessLogsPage';
import AdminImportPage from './pages/AdminImportPage';

const LEGACY_DOMAIN = 'hr-ababa-dashboard.web.app';

const App: React.FC = () => {
  const currentHostname = window.location.hostname;
  const currentPath = window.location.pathname;

  // /new のリダイレクト処理（Legacyドメイン以外の場合のみ）
  useEffect(() => {
    if (currentHostname !== LEGACY_DOMAIN && currentPath === '/new') {
      window.location.replace('/');
    }
  }, [currentHostname, currentPath]);

  // hr-ababa-dashboard.web.app の場合: 全てLegacyDashboard（admin系も含む）
  if (currentHostname === LEGACY_DOMAIN) {
    return <LegacyDashboard />;
  }

  // それ以外のドメイン: admin系のルーティング
  if (currentPath === '/admin/login') {
    return (
      <AuthProvider>
        <AdminLoginPage />
      </AuthProvider>
    );
  }

  if (currentPath === '/admin/companies') {
    return (
      <AuthProvider>
        <AdminCompaniesPage />
      </AuthProvider>
    );
  }

  if (currentPath.startsWith('/admin/dashboard/')) {
    return (
      <AuthProvider>
        <AdminDashboardDetailPage />
      </AuthProvider>
    );
  }

  if (currentPath === '/admin/access-logs') {
    return (
      <AuthProvider>
        <AdminAccessLogsPage />
      </AuthProvider>
    );
  }

  if (currentPath === '/admin/import') {
    return (
      <AuthProvider>
        <AdminImportPage />
      </AuthProvider>
    );
  }

  // admin系以外はNewDashboardを表示
  return <NewDashboard />;
};

export default App;
